import axios from 'axios'
import api from '@/api'
import { sortByKey } from '@/functions'

const ebsRooms = {
  state: {
    data: ''
  },
  getters: {
    getRooms: state => {
      return state.data
    },
    getRoomsMappedLabelValue: state => {
      const rawItems = state.data
      if (!rawItems.length) return []
      return rawItems.map((item) => {
        return {
          label: item.name + item.id,
          customLabel: item.venue.name + ' - ' + item.name,
          value: item.id
        }
      })
    },
    getRoomsMappedIdNameStatus: state => {
      const rawItems = state.data
      if (!rawItems.length) return []
      return rawItems.map((item) => {
        return {
          id: item.id,
          name: item.venue.name + ' - ' + item.name,
          status: item.status
        }
      })
    }
  },
  mutations: {
    SET_ROOMS (state, payload) {
      state.data = sortByKey(payload, 'name')
    },
    CLEAR_ROOMS (state) {
      state.data = ''
    }
  },
  actions: {
    getRooms ({ commit }, data) {
      const requestData = data ? (data.requestData !== undefined ? data.requestData : []) : []
      return new Promise((resolve, reject) => {
        commit('CLEAR_ROOMS')
        axios({
          method: 'post',
          url: `${api.classroom}/rooms/search`,
          data: {
            query: '',
            allowedStatuses: requestData
          }
        }).then(function (response) {
          commit('SET_ROOMS', response.data)
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    }
  }
}

export default ebsRooms
